export default __webpack_public_path__ + "static/media/img-acro-04.7affdc20.jpg";